// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-14uAW";
var _4 = "icon-gc-F2";
var _5 = "wrapper-3Fpj5";
var _6 = "header-3Otcc";
var _7 = "title-1KoOg";
var _8 = "lastMessage-37cb4";
var _9 = "lastMessage__title_wrapper-3fuZN";
var _a = "lastMessage__title-gjPYO";
var _b = "lastMessage__date-1DA5a";
var _c = "lastMessage__text-2e4-B";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "icon", _5 as "wrapper", _6 as "header", _7 as "title", _8 as "lastMessage", _9 as "lastMessage__title_wrapper", _a as "lastMessage__title", _b as "lastMessage__date", _c as "lastMessage__text" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "icon": _4, "wrapper": _5, "header": _6, "title": _7, "lastMessage": _8, "lastMessage__title_wrapper": _9, "lastMessage__title": _a, "lastMessage__date": _b, "lastMessage__text": _c }
